/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { Typography2 } from '@coursera/cds-core';

import { RegionalPromotionFullWidthBanner } from 'bundles/front-page/components/banners/regional-promotion-banner/RegionalPromotionFullWidthBanner';

import _t from 'i18n!nls/xdp';

const GooglePromotionBanner = () => {
  // This div wrapper is required.
  // This wrapper prevents some sort of hydration related bug which leaks into the hero section below.
  return (
    <div
      css={css`
        /* z-index is required to prevent the banner from being overlapped by the image in the hero section */
        z-index: 1;
        position: relative;
      `}
    >
      <RegionalPromotionFullWidthBanner variant="blue">
        <Typography2 component="p" variant="subtitleMedium">
          <FormattedMessage
            message={_t('Enroll today and get Google AI Pro for 3 months ({value} value)')}
            value={
              <FormattedNumber
                value={59.97}
                // eslint-disable-next-line react/style-prop-object
                style="currency"
                currency="USD"
              />
            }
          />
        </Typography2>
      </RegionalPromotionFullWidthBanner>
    </div>
  );
};

export default GooglePromotionBanner;
